
<ng-container *ngIf="isExternal(registerLink); else internal">
    <a target="_blank" [href]="registerLink" [className]='className'
        [textContent]="nameRegisterBtn"></a>
</ng-container>
<ng-template #internal>
    <a [routerLink]="registerLink" [className]='className'
        [textContent]="nameRegisterBtn"></a>
</ng-template>
